export const personalInfoCardId = "personal-info-card";
export const localInfoCardId = "local-info-card";
export const businessInfoCardId = "business-info-card";
export const bankInfoCardId = "bank-info-card";
export const notificationCardId = "notification-card";
export const consultingCardId = "consulting-card";
export const blogCardId = "blog";
export const downloadLinuxAppId = "download-linux-app";
export const downloadMacOSAppId = "download-macos-app";
export const downloadWindowsAppId = "download-windows-app";
export const downloadIOSAppId = "download-ios-app";
export const downloadAndroidAppId = "download-android-app";
export const profileCompletionId = "profile-completion";
export const profileDropdownId = "profile-dropdown";
export const frequentSettingsId = "frequent-settings";
export const frequentProductListId = "frequent-product-list";
export const frequentServicesId = "frequent-services";
export const frequentTokenCreateId = "frequent-token-create";
export const personalPageLinkId = "personalpage-link";
export const personalPageCopyId = "personalpage-copy";
export const downloadPersonalPageQrId = "personalpage-qr";
export const balanceCardId = "balance-card";
export const updateBalanceId = "update-balance";
export const referralOverviewCardId = "referral-overview-card";
export const referralOverviewLinkId = "referral-overview-link";
export const referralMenuDropdownId = "referral-menu-drop-down";
export const changelogMenuDropdownId = "changelog-menu-drop-down";
export const helpMenuDropdownId = "help-menu-drop-down";
export const logoutMenuDropdownId = "logout-menu-drop-down";
export const wizardUserPendingLinkId = "wizard-user-pending-link";
export const wizardDataRejectedLinkId = "wizard-data-rejected-link";
export const wizardHelpLinkId = "wizard-help-link";
export const changePassCardId = "change-pass-card";
export const twoFACardId = "2fa-card";
export const customizeTerminalCardId = "customize-terminal-card";
export const referralModalActivationButtonId = "referral-modal-activation-button";
export const referralCopyCodeId = "referral-copy";
export const referralLinkId = "referral-link";
export const referralModalCloseIcon = "referral-modal-close-icon";
export const referralSubNavItemId = "referral-sub-nav-item";
export const paypingServicesCardId = "payping-services-card";
export const wordpressPluginsCardId = "wordpress-plugins-card";
export const usefulServicesCardId = "useful-services-card";
export const otherServicesCardId = "other-services-card";
export const helpCardId = "help-card";
export const documentCardId = "document-card";
export const filterApplyId = "filter-apply";
export const filterResetId = "filter-reset";
export const filterMoreId = "filter-more";
export const settlementSubNavOverviewId = "settlement-sub-nav-overview";
export const settlementSubNavReportId = "settlement-sub-nav-report";
export const tableRowId = "table-row";
export const tableRowViewIconId = "table-row-view-icon";
export const uploadDraggerId = "upload-dragger";
export const deleteAllErrorsId = "delete-all-errors";
export const backButtonId = "back-button";
export const submitButtonId = "submit-button";
export const tableAddRowButtonId = "table-add-row-button";
export const tablePaginationId = "table-pagination";
export const closeId = "close";
export const ctaId = "cta";
// Navigation's
export const navOverviewId = "nav-overview";
export const navSaleId = "nav-report";
export const navShopId = "nav-solution";
export const navConnectionsId = "nav-connection";
export const navSettlementId = "nav-settle";
export const navMessagesId = "nav-notification";
export const navProfileId = "nav-profile";
export const navDigitalAccountId = "nav-digitalaccount";
// Cta's
export const ctaLoginSettleId = "cta-settle";
export const ctaBusinessSettingId = "cta-bsetting";
export const ctaSolutionNavigationId = "cta-solution-navigation";
export const ctaCreateId = "cta-create";
export const ctaMultiCreateId = "cta-multicreate";
export const ctaTokenId = "cta-token";
export const ctaEnterZifyId = "cta-enterzify";

// Card's
export const cardLinkId = "card-link";
export const cardDetailId = "card-detail";
export const cardEditId = "card-edit";
export const cardArchiveId = "card-archive";
export const cardDeleteId = "card-delete";
export const pluginId = "plugin";
export const referralId = "referral";
export const sliderWebinarId = "slider-webinar-id";
// Redirect
export const redirectToOldDashboardId = "changetoold";
// Ipg's
export const ipgTechDocId = "ipg-techdoc";
export const ipgHelpId = "ipg-help";
export const ipgWithdrawId = "ipg-withdraw";
export const ipgAllPaymentId = "ipg-allpayment";
// Connection's
export const connectionWordpressPluginId = "connection-wplugin";
export const connectionDevelopersId = "connection-developers";
// Report's
export const reportPaymentId = "report-payment";
// Solution's
export const solutionInvoiceId = "solution-invoice";
export const solutionProductsId = "solution-products";
// Chart's
export const chartWeekId = "chart-week";
export const chartMonthId = "chart-month";
export const chartYearId = "chart-year";
// Segment Display
export const segmentDisplayId = "display";
// Date
export const dateId = "date";
// Search
export const searchId = "search";
// Filter
export const filterId = "filter";
// Pdf
export const pdfDownloadId = "pdfDownload";
// Excel
export const excelDownloadId = "excelDownload";
// Token
export const tokenId = "token";
// detail
export const detailId = "detail";
// receipt
export const receiptId = "receipt";
// request list
export const requestListId = "requestlist";
// Webservices Document
export const paymentDocumentId = "payment-document";
export const reportDocumentId = "report-document";
export const withdrawDocumentId = "withdraw-document";
export const invoiceDocumentId = "invoice-document";
export const allDocumentId = "all-document";
export const postmanTemplateDownloadId = "postmantemplate-download";
export const webserviceHelpId = "webservice-help";
// Webservices Resource
export const sdkGithubLinkId = "sdk-githublink";
export const csharpGithubLinkId = "csharp-githublink";
export const phpGithubLinkId = "php-githublink";
export const laravelGithubLinkId = "laravel-githublink";
// Settlement Overview
export const activationHelpId = "activationhelp";
export const depositCodeCreateId = "depositcode-create";
export const listViewId = "listView";
export const lastRequestsViewAllId = "lastrequests-viewall";
export const settleServiceLinkId = "settleservice-link";
export const paymentServiceLinkId = "paymentservice-link";

//
export const clickbaitTransferId = "clickbait-transfer";
export const clickbaitAccountManagementId = "clickbait-accountmanagement";
export const clickbaitShortTermLoanId = "clickbait-shorttermloan";
export const clickbaitEarlySettlementId = "clickbait-earlysettlement";
export const mobilelinkId = "mobilelink";
export const guideId = "guide";
export const fileDownloadId = "file-download";
export const fileUploadId = "file-upload";
export const continueId = "continue";
export const cancelId = "cancel";
export const haveAccountId = "haveaccount";
export const noAccountId = "noaccount";
export const guideMapId = "guide-map";
export const guideBrancesId = "guide-brances";
export const offlineReportId = "offlinereport";
export const reportId = "report";
export const deleteErrorsId = "deleteerrors";
export const typeId = "type";
export const deleteId = "delete";
export const editId = "edit";
